<section
  class="flex flex-col gap-8 rounded-[--tui-radius-l] bg-background-neutral-1 p-8 text-center md:p-12"
>
  <h2 class="text-3xl font-bold md:text-4xl">
    Ready to scale your app development?
  </h2>
  <p class="text-balance text-xl">
    Join leading enterprises who trust Capawesome Cloud for Live Updates, Native
    Builds, and App Store Publishing at scale. Get started with a personalized
    demo today.
  </p>
  <div class="flex flex-col gap-2">
    <div class="flex flex-col justify-center gap-4 sm:flex-row">
      <a
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="bookingUrl"
        target="_blank"
        data-umami-event="enterprise-cta-request-demo-button"
      >
        Book a demo
      </a>
      <button
        appearance="outline"
        size="l"
        tuiAppearanceMode="checked"
        tuiButton
        type="button"
        (click)="handleContactSales()"
        data-umami-event="enterprise-cta-contact-sales-button"
      >
        Contact sales
      </button>
    </div>
    <p class="text-text-tertiary text-sm">
      Questions?
      <a
        class="text-primary hover:underline"
        [href]="discordUrl"
        target="_blank"
      >
        Join our Discord
      </a>
      or
      <a class="text-primary hover:underline" routerLink="/contact/">
        contact us </a
      >.
    </p>
  </div>
</section>
